import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import { logError } from "@entrilia/shared/logging";
import { numberComparerBy } from "@entrilia/shared/utilities/arrayHelper";
import adminApi from "../../../../api/adminApi";
import type { SelectOption } from "../../../common/filters/filterTypes";

const getAccessCategories = withErrorHandling(adminApi.getAccessCategories);

const getCategoryOptions = async () => {
  const [categories, error] = await getAccessCategories();
  if (error) {
    logError(error, "[getSelectOptionsForDocumentViews] getAccessCategories");
    return [];
  }

  return categories.sort(numberComparerBy((c) => c.sortOrder)).map((c) => ({ value: c.id, label: c.name }));
};

const fetchFunds = () => adminApi.getObjectsAsLookupReferences("Fund");

const getFundOptions = async (): Promise<SelectOption[]> => {
  const [funds, error] = await withErrorHandling(fetchFunds)();
  if (error) {
    logError(error, "[getSelectOptionsForDocumentViews] getObjectsAsLookupReferences");
    return [];
  }

  return funds.map((fund) => ({ value: fund.objectId, label: fund.primaryFieldValue }));
};

const fetchInvestors = () => adminApi.getObjectsAsLookupReferences("Investor");

const getInvestorOptions = async (): Promise<SelectOption[]> => {
  const [investors, error] = await withErrorHandling(fetchInvestors)();
  if (error) {
    logError(error, "[getSelectOptionsForDocumentViews] getObjectsAsLookupReferences");
    return [];
  }

  return investors.map((investor) => ({ value: investor.objectId, label: investor.primaryFieldValue }));
};

export const getSelectOptionsForDocumentViews = async (filterId: string): Promise<SelectOption[]> => {
  switch (filterId) {
    case "categoryIds":
      return getCategoryOptions();
    case "fundIds":
      return getFundOptions();
    case "investorIds":
      return getInvestorOptions();
    default: {
      logError(`Unknown async select filterId: ${filterId}`, "[getSelectOptionsForDocumentViews]");
      return [];
    }
  }
};
